export const Types = {
  GET_LIST_PROPOSTAS_ALERTAS: "propostasAlertas/GET_LIST_PROPOSTAS_ALERTAS",
  GET_LIST_PROPOSTAS_ALERTAS_SUCCESS:
    "propostasAlertas/GET_LIST_PROPOSTAS_ALERTAS_SUCCESS",
  GET_PROPOSTAS_ALERTAS: "propostasAlertas/GET_PROPOSTAS_ALERTAS",
  GET_PROPOSTAS_ALERTAS_SUCCESS:
    "propostasAlertas/GET_PROPOSTAS_ALERTAS_SUCCESS",
  GET_PROPOSTAS_ALERTAS_COUNT: "propostasAlertas/GET_PROPOSTAS_ALERTAS_COUNT",
  GET_PROPOSTAS_ALERTAS_COUNT_SUCCESS:
    "propostasAlertas/GET_PROPOSTAS_ALERTAS_COUNT_SUCCESS",
  CHANGE_PAGE_PROPOSTAS_ALERTAS:
    "propostasAlertas/CHANGE_PAGE_PROPOSTAS_ALERTAS",
  CHANGE_ROWS_PER_PAGE_PROPOSTAS_ALERTAS:
    "propostasAlertas/CHANGE_ROWS_PER_PAGE_PROPOSTAS_ALERTAS",
  GET_LIST_PROPOSTAS_ALERTAS_SUCCESS_SELECTS:
    "propostasAlertas/GET_LIST_PROPOSTAS_ALERTAS_SUCCESS_SELECTS",
  CHANGE_FILTER: "propostasAlertas/CHANGE_FILTER",
  PRINT_ALERTAS: "propostasAlertas/PRINT_ALERTAS",
  PRINT_SUCCESS: "propostasAlertas/PRINT_SUCCESS",
  DELETE_PROPOSTAS_ALERTAS: "propostasAlertas/DELETE_PROPOSTAS_ALERTAS",
};

const INITIAL_STATE = {
  data: [],
  dataPayload: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0,
  total_financed: 0,
  total_released: 0,
  total_receipted_total: 0,
  total_estornado_total: 0,
  total_comissioned_total: 0,
  total_value_installment: 0,
  total_base: 0,
  print: "",
  count: 0,
  columns_settings: [],
};

export default function propostasAlertas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_PROPOSTAS_ALERTAS:
      return { ...state };
    case Types.GET_LIST_PROPOSTAS_ALERTAS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        total_financed: action.payload.total_financed,
        total_released: action.payload.total_released,
        total_base: action.payload.total_base,
        total_receipted_total: action.payload.total_receipted_total,
        total_estornado_total: action.payload.total_estornado_total,
        total_comissioned_total: action.payload.total_comissioned_total,
        total_value_installment: action.payload.total_value_installment,
        columns_settings: JSON.parse(action.payload.columns_settings),
        dataPayload: action.payload.propostasAlertasPayload,
      };
    case Types.GET_PROPOSTAS_ALERTAS_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
      };
    case Types.CHANGE_PAGE_PROPOSTAS_ALERTAS:
      return { ...state, page: action.payload.page };
    case Types.CHANGE_ROWS_PER_PAGE_PROPOSTAS_ALERTAS:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.GET_LIST_PROPOSTAS_ALERTAS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.propostasAlertas,
        loadingSelect: false,
      };
    case Types.DELETE_PROPOSTAS_ALERTAS:
      return { ...state };
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data,
      };
    case Types.PRINT_SUCCESS:
      return { ...state, print: action.payload.url };
    case Types.GET_PROPOSTAS_ALERTAS_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data.total,
      };
    default:
      return state;
  }
}

export const Creators = {
  getListPropostasAlertas: () => ({
    type: Types.GET_LIST_PROPOSTAS_ALERTAS,
  }),
  getListPropostasAlertasSuccess: (
    data,
    total,
    total_financed,
    total_released,
    total_base,
    total_receipted_total,
    total_estornado_total,
    total_comissioned_total,
    total_value_installment,
    columns_settings,
    propostasAlertasPayload
  ) => ({
    type: Types.GET_LIST_PROPOSTAS_ALERTAS_SUCCESS,
    payload: {
      data,
      total,
      total_financed,
      total_released,
      total_base,
      total_receipted_total,
      total_estornado_total,
      total_comissioned_total,
      total_value_installment,
      columns_settings,
      propostasAlertasPayload,
    },
  }),
  getPropostasAlertas: (id) => ({
    type: Types.GET_PROPOSTAS_ALERTAS,
    payload: { id },
  }),
  getPropostasAlertasSuccess: (data) => ({
    type: Types.GET_PROPOSTAS_ALERTAS_SUCCESS,
    payload: { data },
  }),
  changePropostasAlertasPage: (page) => ({
    type: Types.CHANGE_PAGE_PROPOSTAS_ALERTAS,
    payload: { page },
  }),
  changePropostasAlertasRowsPerPage: (total) => ({
    type: Types.CHANGE_ROWS_PER_PAGE_PROPOSTAS_ALERTAS,
    payload: { total },
  }),
  getListPropostasAlertasSuccessSelects: (propostasAlertas) => ({
    type: Types.GET_LIST_PROPOSTAS_ALERTAS_SUCCESS_SELECTS,
    payload: { propostasAlertas },
  }),
  changeFilter: (data) => ({
    type: Types.CHANGE_FILTER,
    payload: { data },
  }),
  deletePropostasAlertas: () => ({
    type: Types.DELETE_PROPOSTAS_ALERTAS,
  }),
  printAlertas: (id) => ({
    type: Types.PRINT_ALERTAS,
    payload: { id },
  }),
  printSuccess: (url) => ({
    type: Types.PRINT_SUCCESS,
    payload: { url },
  }),
  getPropostasAlertasCount: () => ({
    type: Types.GET_PROPOSTAS_ALERTAS_COUNT,
  }),
  getPropostasAlertasCountSuccess: (data) => ({
    type: Types.GET_PROPOSTAS_ALERTAS_COUNT_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/propostasAlertas.js